<template>
  <div ref="googleWrapper"></div>
</template>

<script>
  import { USER_STATUSES } from "@/constant";
  import { mixpanelWrapper } from "@/@core/libs/mixpanel";

  export default {
    data() {
      return {
        googleAuthKey: process.env.VUE_APP_GOOGLE_AUTH_KEY,
      };
    },
    created() {
      window.addEventListener("resize", this.renderButton);
    },
    mounted() {
      if (this.$refs.googleWrapper) {
        window.google.accounts.id.initialize({
          client_id: this.googleAuthKey,
          context: "signin",
          ux_mode: "popup",
          callback: this.googleLoginCall,
          auto_prompt: "false",
        });
        setTimeout(() => {
          this.renderButton();
        }, 0);
      }
    },
    destroyed() {
      window.removeEventListener("resize", this.renderButton);
    },
    methods: {
      renderButton() {
        window.google.accounts.id.renderButton(this.$refs.googleWrapper, {
          type: "standard",
          shape: "rectangular",
          theme: this.$vuetify.theme.dark ? "filled_blue" : "outline",
          text: "continue_with",
          size: "large",
          logoAlignment: "left",
          width: this.$refs.googleWrapper.offsetWidth,
        });
      },
      async googleLoginCall(res) {
        try {
          const response = await this.$admin.dataProvider.customHttpCall("POST", "auth/login/google", res);
          if (response.status === 200) {
            // We just received fresh user data. Set it to store (no need for /current call)
            this.$store.dispatch("SET_USER_DATA", response.data.user);
            if (response.data.user.status === USER_STATUSES.PARTIALLY_REGISTERED) {
              this.drip.push([
                "identify",
                {
                  email: response.data?.user?.email,
                  step: 1,
                  tags: ["Incomplete Registration"],
                },
              ]);
              mixpanelWrapper.track("Credentials Filled", { previous_page: this.$store.getters["getPreviousRoute"] });
              this.$router.push({
                name: "complete-register",
              });
            } else {
              this.$router.push({ name: "dashboard" });
            }
          }
        } catch (e) {
          this.errorMessages = e;
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
